var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPracticeMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6568_8266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9855 17.5112C24.7211 15.8241 25.6737 13.5638 25.6737 11.1501C25.6737 8.73646 24.592 6.21784 22.7111 4.53069C20.8302 2.85162 18.3035 2.04437 15.7768 2.32691C11.7244 2.77897 8.44701 6.04025 7.97073 10.0846C7.64783 12.8615 8.60038 15.5738 10.5943 17.5112C11.1916 18.0925 11.5388 18.9239 11.5388 19.7877V20.8452H11.1351C10.6912 20.8452 10.3279 21.2084 10.3279 21.6524C10.3279 22.0964 10.6912 22.4597 11.1351 22.4597H12.7496V24.0742C12.7496 25.4061 13.8394 26.4959 15.1714 26.4959H18.4004C19.7323 26.4959 20.8221 25.4061 20.8221 24.0742V22.4597H22.4366C22.8806 22.4597 23.2439 22.0964 23.2439 21.6524C23.2439 21.2084 22.8806 20.8452 22.4366 20.8452H22.033V19.7877C22.033 18.9239 22.3801 18.1005 22.9775 17.5112H22.9855ZM19.2157 24.0661C19.2157 24.5101 18.8524 24.8733 18.4084 24.8733H15.1795C14.7355 24.8733 14.3722 24.5101 14.3722 24.0661V22.4516H19.2157V24.0661ZM13.1613 20.8371V19.7796C13.1613 18.488 12.6366 17.2368 11.7325 16.3488C10.1019 14.7585 9.31883 12.5467 9.58522 10.2702C9.9727 6.96051 12.6528 4.29659 15.9625 3.92526C18.0694 3.69116 20.0794 4.32888 21.6455 5.72542C23.1874 7.10581 24.0673 9.0755 24.0673 11.1421C24.0673 13.2086 23.2842 14.9684 21.8715 16.3488C20.9593 17.2368 20.4346 18.488 20.4346 19.7796V20.8371H13.1694H13.1613Z",
    fill: "#CFE92A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6568_8266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0957 10.3418H27.2884C26.8445 10.3418 26.4812 10.7051 26.4812 11.149C26.4812 11.593 26.8445 11.9563 27.2884 11.9563H28.0957C28.5397 11.9563 28.9029 11.593 28.9029 11.149C28.9029 10.7051 28.5397 10.3418 28.0957 10.3418Z",
    fill: "#CFE92A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6568_8266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4808 7.92097C26.6019 7.92097 26.7229 7.89675 26.844 7.83217L28.4585 7.02492C28.8541 6.82311 29.0155 6.33876 28.8218 5.94321C28.6281 5.54766 28.1356 5.38621 27.7401 5.57995L26.1256 6.3872C25.73 6.58901 25.5686 7.07336 25.7623 7.46891C25.9076 7.75145 26.1902 7.9129 26.4888 7.9129L26.4808 7.92097Z",
    fill: "#CFE92A"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6568_8266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4587 15.275L26.8443 14.4677C26.4406 14.2659 25.9563 14.4274 25.7625 14.831C25.5688 15.2346 25.7222 15.7109 26.1258 15.9127L27.7403 16.72C27.8533 16.7765 27.9825 16.8088 28.1036 16.8088C28.4022 16.8088 28.6848 16.6473 28.8301 16.3648C29.0319 15.9692 28.8704 15.4849 28.4668 15.2831L28.4587 15.275Z",
    fill: "#CFE92A"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_6568_8266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49255 11.9563H6.2998C6.74378 11.9563 7.10705 11.593 7.10705 11.149C7.10705 10.7051 6.74378 10.3418 6.2998 10.3418H5.49255C5.04856 10.3418 4.6853 10.7051 4.6853 11.149C4.6853 11.593 5.04856 11.9563 5.49255 11.9563Z",
    fill: "#CFE92A"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_6568_8266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4701 6.39413L5.85561 5.58688C5.45198 5.38507 4.96763 5.54652 4.77389 5.95014C4.57208 6.3457 4.73353 6.83004 5.13716 7.03186L6.75165 7.8391C6.86467 7.89561 6.99383 7.9279 7.11491 7.9279C7.4136 7.9279 7.69613 7.76645 7.84144 7.48391C8.04325 7.08836 7.8818 6.60401 7.47817 6.4022L7.4701 6.39413Z",
    fill: "#CFE92A"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_6568_8266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.74374 14.4669L5.12925 15.2742C4.73369 15.476 4.57225 15.9603 4.76598 16.3559C4.91129 16.6384 5.19383 16.7999 5.49251 16.7999C5.61359 16.7999 5.73468 16.7757 5.85577 16.7111L7.47026 15.9038C7.86582 15.702 8.02727 15.2177 7.83353 14.8221C7.63171 14.4266 7.14737 14.2651 6.75181 14.4589L6.74374 14.4669Z",
    fill: "#CFE92A"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_6568_8266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8304 14.8457C21.2744 14.8457 21.6377 14.4824 21.6377 14.0384V8.32313C21.6377 7.87915 21.2744 7.51589 20.8304 7.51589H20.6932C19.4097 7.51589 18.2311 7.78228 17.1816 8.30699L16.7942 8.50073L16.4067 8.30699C15.3573 7.78228 14.1787 7.50781 12.8952 7.50781H12.7579C12.3139 7.50781 11.9507 7.87107 11.9507 8.31506V14.0304C11.9507 14.4744 12.3139 14.8376 12.7579 14.8376H12.8952C14.0576 14.8376 15.2039 15.1605 16.2049 15.7821L16.3663 15.879C16.4955 15.9597 16.6408 16.0001 16.7861 16.0001C16.9314 16.0001 17.0767 15.9597 17.2059 15.879L17.3673 15.7821C18.3683 15.1686 19.5146 14.8376 20.677 14.8376H20.8143L20.8304 14.8457ZM13.5652 9.16267C14.3321 9.23532 15.0424 9.42906 15.6802 9.75196L15.9869 9.90534V13.8609C15.212 13.5299 14.3966 13.3281 13.5652 13.2554V9.1546V9.16267ZM20.0232 13.2635C19.1917 13.3361 18.3683 13.538 17.6014 13.8689V9.91341L17.9082 9.76003C18.5459 9.43713 19.2563 9.2434 20.0232 9.17074V13.2716V13.2635Z",
    fill: "#CFE92A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6568_8266",
    x: 5.74003,
    y: 0.102577,
    width: 22.1025,
    height: 28.5624,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6568_8266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6568_8266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6568_8266",
    x: 24.3123,
    y: 8.17289,
    width: 6.75945,
    height: 5.95305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6568_8266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6568_8266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6568_8266",
    x: 23.5115,
    y: 3.32914,
    width: 7.5612,
    height: 6.76164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6568_8266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6568_8266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6568_8266",
    x: 23.5103,
    y: 12.212,
    width: 7.57561,
    height: 6.76555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6568_8266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6568_8266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_6568_8266",
    x: 2.5164,
    y: 8.17289,
    width: 6.75945,
    height: 5.95305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6568_8266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6568_8266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_6568_8266",
    x: 2.5181,
    y: 3.33109,
    width: 7.57903,
    height: 6.76555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6568_8266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6568_8266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_6568_8266",
    x: 2.51517,
    y: 12.208,
    width: 7.56926,
    height: 6.76164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6568_8266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6568_8266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_6568_8266",
    x: 9.78178,
    y: 5.33891,
    width: 14.0248,
    height: 12.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6568_8266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6568_8266",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeMode);
export default __webpack_public_path__ + "static/media/practice-mode.513e428fab5427251a9577e02f299a86.svg";
export { ForwardRef as ReactComponent };